import './plans.style.sass';
import template from './plans.tpl.pug';

/* @ngInject */
function PlansController($state, apiService) {
    this.$state = $state;
    this.apiService = apiService;
    this.loading = true;
    this.plans = [];

    this.$onInit = function () {
        let self = this;
        // Fetch available plans from API
        this.apiService.get('/subscriptions/plans', {
            params: {
                upgradeOnly: false,
                withPrice: true
            }
        })
            .then((response) => {
                self.plans = self._transformPlans(response.data);
                self.loading = false;
            })
            .catch(function () {
                // Fallback to default plans if API fails
                this.plans = [
                    {
                        id: 'pro-monthly',
                        type: 'Pro',
                        name: 'Monthly',
                        price: '$5',
                        period: 'per month',
                        features: [
                            'Smart Calendar View',
                            'AI-Powered Insights',
                            'Bank Account Sync',
                            'Smart Budgeting',
                            'Unlimited Categories'
                        ]
                    },
                    {
                        id: 'pro-annual',
                        type: 'Pro',
                        name: 'Annual',
                        price: '$48',
                        period: 'per year',
                        savings: 'Save 20%',
                        features: [
                            'Smart Calendar View',
                            'AI-Powered Insights',
                            'Bank Account Sync',
                            'Smart Budgeting',
                            'Unlimited Categories'
                        ]
                    },
                    {
                        id: 'unlimited-monthly',
                        type: 'Pro Unlimited',
                        name: 'Monthly',
                        price: '$10',
                        period: 'per month',
                        features: [
                            'All Pro Features',
                            'Priority Support',
                            'Advanced Analytics',
                            'Export to Excel',
                            'Family Sharing'
                        ]
                    },
                    {
                        id: 'unlimited-annual',
                        type: 'Pro Unlimited',
                        name: 'Annual',
                        price: '$96',
                        period: 'per year',
                        savings: 'Save 20%',
                        features: [
                            'All Pro Features',
                            'Priority Support',
                            'Advanced Analytics',
                            'Export to Excel',
                            'Family Sharing'
                        ],
                        recommended: true
                    }
                ];
            });
    };
}

PlansController.prototype._transformPlans = function (apiPlans) {
    return apiPlans
        .filter((plan) => {
            return plan.subscriptions && plan.subscriptions.length > 0;
        })
        .reduce((acc, plan) => {
            let planSubs = plan.subscriptions.map((sub) => {
                return {
                    id: sub.id.toString(),
                    type: plan.name,
                    name: sub.title,
                    price: sub.currency + sub.price,
                    period: sub.frequency === 1 ? 'per month' : 'per year',
                    features: plan.features,
                    savings: sub.frequency === 12 ? 'Save 20%' : null,
                    recommended: plan.name === 'Pro Unlimited' && sub.frequency === 12,
                    // Ensure color is lowercase and has fallback
                    color: plan.color ? plan.color.toLowerCase() : '#00a3ff'
                };
            });
            return acc.concat(planSubs);
        }, []);
};

PlansController.prototype.selectPlan = function (plan) {
    this.selectedPlan = plan;
};

PlansController.prototype.nextStep = function () {
    if (this.selectedPlan) {
        this.onSubmit({ questionKey: 'selected_plan', answer: this.selectedPlan.id });
        this.$state.go('conversion-quiz.register');
    }
};

export default {
    template: template(),
    controller: PlansController,
    bindings: {
        onSubmit: '&'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/plans/plans.cmpt.js